<template>
    <div>
        <pdpa-headline
            :header="pdpaHeader"></pdpa-headline>
        <div class="pdpa-content" ref="termsRegisterModal" @scroll="onScroll()" v-html="pdpaContenttxt"></div>
        <div v-if="!bottomOfContent && !hideTabToBottom" @click="scrollToElement()" class="tab-to-bottom">
            <div class="text-tab">
                {{ lbl.register.tab_to_bottom }}
            </div>
            <img src="@/assets/icon/ic-double-down-new-green.svg" alt="">
        </div>
        
        <!-- <ModalMaster :controller="modalController" :theme="userType" /> -->
    </div>
</template>
<script>
//component
import PdpaHeadline from "../Component/PDPAHeader.vue";
//import PdpaTopicList from "../Component/PDPATopicList.vue";
//error
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//service
import PDPAService from "@/core/PDPA/service/BzbsPDPA.js";
//modal
// import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
import Locale from '@/helper/locale/locale.js';
export default {
    name: 'pdpa',
    mixins: [
        ErrorApiMixin
    ],
    components: {
        PdpaHeadline,
        //PdpaTopicList,
        // ModalMaster
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    props: {
        lblCode: Number,
        controller: Object,
        busPDPA: Object,
        hideTabToBottom: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            currentNo: '',
            pdpaHeader: {},
            pdpaContent: [],
            pdpaContenttxt: "",
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            loadingModal: new LoadingModalController(),
            bottomOfContent: false,
            lbl: Locale.getLbl(),
        };
    },
    created: function () {
        this.initialPDPA();
        //modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setLoadingModal(this.loadingModal);
        //error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);
        this.bottomOfContent = false;
    },
    mounted: function () {
        if (this.busPDPA)
            this.busPDPA.$on('initialPDPA', this.initialPDPA);
    },
    methods: {
        initialPDPA: function () {
            this.getPDPAVesion()
                .then((versionResult) => {
                    var version = versionResult.data.terms.current_version;
                    return this.getPDPAContent(version);
                })
                .then((contentResult) => {
                    //console.log(contentResult.data);
                    this.pdpaContenttxt = contentResult.data;
                    // this.pdpaHeader = contentResult.data.header;
                    // this.pdpaContent = contentResult.data.content;
                })
                .catch((error) => {
                    this.errorResponse(error, this.errorHandler);
                });
        },
        getPDPAVesion: function () {
            return PDPAService.apiGetPDPAVersion();
        },
        getPDPAContent: function (version) {
            return PDPAService.apiGetPDPAContent("terms", version, this.lblCode);
        },
        onScroll () {
            const element = this.$refs.termsRegisterModal;
            const clientHeight = element.clientHeight;
            const scrollHeight = element.scrollHeight;
            const scrollTop = element.scrollTop;
            if (scrollTop + clientHeight >= scrollHeight-28) {
                this.bottomOfContent = true;
            }else{
                this.bottomOfContent = false;
            }
            this.$emit('onScroll',this.bottomOfContent);
        },
        scrollToElement: function () {
            const el = this.$refs.termsRegisterModal;
            const heightScroll  = el.scrollHeight
            el.scrollTo({
                top: heightScroll,
                behavior: "smooth",
            });
            this.bottomOfContent = true;
        }
    }
}
</script>
<style lang="scss">
@import "@/components/PDPA/Page/pdpa.scss";
</style>
